// @flow
import Spinner from 'components/Spinner'
import { useLoadBilling } from 'queries/payments/useLoadBilling'
import * as React from 'react'
import Flex from 'ui/atoms/Flex'
import FlexBox from 'ui/atoms/FlexBox'
import Pagination from 'ui/atoms/Pagination'
import Table from 'ui/atoms/Table'
import Text from 'ui/atoms/Text'
import { getFormattedDate } from 'utils/dates'

function Invoices(): React.Node {
  const { data, isLoading } = useLoadBilling()
  const [page, setPage] = React.useState(1)
  const total = React.useMemo(
    () => data?.invoices?.length || 0,
    [data?.invoices?.length]
  )

  const invoices = React.useMemo(() => {
    if (!data?.invoices?.length) return []
    return data.invoices.slice((page - 1) * 5, page * 5)
  }, [data?.invoices, page])

  const getAmount = React.useCallback((amount) => {
    if (!amount) return ''
    return `$${amount}`
  }, [])

  return (
    <FlexBox className="max-w-2xl">
      <Table.Title>
        <Flex className="w-full">
          <Text>Invoices</Text>
        </Flex>
      </Table.Title>
      <div className="overflow-y-auto">
        <Table>
          <Table.Head columns={['DATE', 'AMOUNT', 'PLAN', 'DOWNLOAD']} />
          <Table.Body>
            {isLoading || !invoices.length ? (
              <Table.Row>
                <Table.Column>
                  {isLoading ? (
                    <Spinner color="onLight" />
                  ) : (
                    <Text>You haven't received any invoices yet.</Text>
                  )}
                </Table.Column>
                <Table.Column />
                <Table.Column />
                <Table.Column />
              </Table.Row>
            ) : (
              invoices.map((invoice) => (
                <Table.Row key={invoice.id}>
                  <Table.Column>
                    <Text>{getFormattedDate(invoice.created)}</Text>
                  </Table.Column>
                  <Table.Column>
                    <Text>{getAmount(invoice.amount)}</Text>
                  </Table.Column>
                  <Table.Column>
                    <Text>{invoice.plan_name}</Text>
                  </Table.Column>
                  <Table.Column>
                    <a
                      href={invoice.invoice_pdf}
                      rel="noreferrer"
                      target="_blank"
                    >
                      <Text $active className="cursor-pointer">
                        PDF
                      </Text>
                    </a>
                  </Table.Column>
                </Table.Row>
              ))
            )}
          </Table.Body>
        </Table>
      </div>
      <Pagination.Border>
        <Pagination
          nextCallback={() => {
            if (page <= total / 5) {
              setPage(page + 1)
            }
          }}
          page={page}
          pageSize={5}
          previousCallback={() => {
            if (page > 1) {
              setPage(page - 1)
            }
          }}
          total={total}
        />
      </Pagination.Border>
    </FlexBox>
  )
}

export default Invoices
